





import { FetchPrivateFileObjectUrl, IsPrivateFileUrl } from "@/helper/uploadHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class PrivateImage extends Vue {
  @Prop({ type: String, default: "" })
  readonly src!: string;

  private resolvedSrc = "";

  // ไม่ abort เพราะ request ถูกแชร์กับคอมโพเนนต์อื่น ใช้ token ทิ้งผลที่ล้าสมัยแทน
  private loadToken = 0;

  mounted() {
    this.LoadSrc();
  }

  beforeDestroy() {
    this.loadToken += 1;
    this.ReleaseResolved();
  }

  @Watch("src")
  onSrcChanged() {
    this.LoadSrc();
  }

  private ReleaseResolved() {
    this.Release(this.resolvedSrc);
    this.resolvedSrc = "";
  }

  private Release(objectUrl: string) {
    if (objectUrl.startsWith("blob:")) {
      URL.revokeObjectURL(objectUrl);
    }
  }

  private async LoadSrc() {
    this.loadToken += 1;
    const token = this.loadToken;
    if (!this.src) {
      this.ReleaseResolved();
      return;
    }
    if (!IsPrivateFileUrl(this.src)) {
      this.ReleaseResolved();
      this.resolvedSrc = this.src;
      return;
    }
    try {
      const objectUrl = await FetchPrivateFileObjectUrl(this.src);
      if (token !== this.loadToken) {
        this.Release(objectUrl);
        return;
      }
      this.ReleaseResolved();
      this.resolvedSrc = objectUrl;
    } catch (error) {
      if (token === this.loadToken) {
        this.ReleaseResolved();
        this.$emit("error", error);
      }
    }
  }
}
